import React from "react";

/**
 * Context to hold a callback to call to display a loader. The nearest Loader parent will catch this, hide its
 * children, and display a loader instead. Use this to avoid multiple loaders on a page.
 */
export default React.createContext(null);
